import React from "react";
import "./EventInfoSection.css";
import { formatDate } from "../../utils/formatDate";

const EventInfoSection = ({ event }) => {
  const details = [
    { label: "Event Id", value: event.id },
    { label: "Event Name", value: event.name },
    { label: "W9 Entity", value: event.w9_entity_name },  
    { label: "Date", value: formatDate(event.event_date) },
    { label: "Registration Count", value: event.RegistrationCount },
    {
      label: "Registration Total",
      value: `$${event.RegistrationSum.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}`,
    },
    {
      label: "Processed Funds Total",
      value: `$${event.ProcessedFundsRequestSum.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}`,
    },
    {
      label: "Unprocessed Funds Total",
      value: `$${event.UnProcessedFundsRequestSum.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}`,
    },
  ];

  return (
    <section className="event-info">
      <h2 className="event-info__title">Event Information</h2>
      <div className="event-info__content">
        {details.map((detail, index) => (
          <div key={index} className="event-info__row">
            <span className="event-info__label">{detail.label}:</span>
            <span className="event-info__value">{detail.value}</span>
          </div>
        ))}
      </div>
    </section>
  );
};

export default EventInfoSection;
